module.exports = __webpack_public_path__ + "img/mps_img.2574030f.png";